// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"ListB_TheComp__O51Uz"};